import React from 'react';
import {Button} from "react-bootstrap";
import HttpRequest from "../../Common/Http/HttpRequest";
import Notify from "../../Common/Notify/Notify";

export const BaixarNFEButton = ({}) => {


    const procurarNovasNotas = () => {
        HttpRequest.put(`${process.env.REACT_APP_NODE_SERVICE}dinamica/try-import-nfe-in-sefaz`, {}).then(() => {
            Notify.success('Buscando notas, isso pode demorar...');
        }, err => {
            Notify.error('Falha ao bucar notas', err);
        })
    }

    return <Button variant="primary" title="Procurar novas notas dentro do SEFAZ" onClick={procurarNovasNotas}>
        Baixar NFE
    </Button>

}



